// TODO: Create src/components/ folder and add Navbar/Footer components for modular UI
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import SEO from './components/SEO';
import Footer from './components/Footer';
import HeroSection from './components/HeroSection';
// import MissionSection from './components/MissionSection';
import WorkSection from './components/WorkSection';
import VideoGallerySection from './components/VideoGallerySection';
import TestimonialsSection from './components/TestimonialsSection';
import AboutSection from './components/AboutSection';
import FloatingTranslate from './components/FloatingTranslate';

import AboutPage from './components/AboutPage';
import Gallery from './components/Gallery';
import GalleryPage from './components/GalleryPage';
import SocialMediaSection from './components/SocialMediaSection';
import JivanYatraSection from './components/JivanYatraSection';
import ImpactSection from './components/ImpactSection';
import AppointmentSection from './components/AppointmentSection';
import ContactPage from './components/ContactPage';
import EventsAdmin from './admin/EventsAdmin';
import Sitemap from './components/Sitemap';
import { Routes, Route } from 'react-router-dom';
import AdminLayout from './admin/AdminLayout';
import GalleryAdmin from './admin/GalleryAdmin';
import AdminLogin from './admin/AdminLogin';
import AdminDashboard from './admin/AdminDashboard';
import VideosAdmin from './admin/VideosAdmin';
import AppointmentsAdmin from './admin/AppointmentsAdmin';
import ContactsAdmin from './admin/ContactsAdmin';
import KaryaPage from './components/KaryaPage';
import KaryaDetailPage from './components/KaryaDetailPage';
import PressAdmin from './admin/PressAdmin';
import JoinUsAdmin from './admin/JoinUsAdmin';

import PressPage from './components/PressPage';
import VideoPage from './components/VideoPage';
import JoinUsPage from './components/JoinUsPage';
import RachnayePage from './components/RachnayePage';
import BlogPage from './components/BlogPage';
import RachnayeDetailPage from './components/RachnayeDetailPage';
import BlogDetailPage from './components/BlogDetailPage';
import RachnayeAdmin from './admin/RachnayeAdmin';
import BlogAdmin from './admin/BlogAdmin';
import CommentsAdmin from './admin/CommentsAdmin';

// Scroll to top on route change and handle hash anchors
const ScrollToTop = () => {
  const location = useLocation();
  useEffect(() => {
    // If there is a hash, attempt smooth scroll to element
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
    }
    // Default: scroll to page top
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [location.pathname, location.hash]);
  return null;
};

function App() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');
  const isPublicRoute = !isAdminRoute;
  
  // Helper component to render common layout for public routes
  const PublicRoute = ({ children }) => (
    <div className="w-full">
      {children}
      {isPublicRoute && (
        <>
          <Footer />
          <FloatingTranslate />
        </>
      )}
    </div>
  );

  return (
    <div className="min-h-screen flex flex-col">
      <ScrollToTop />
      {isPublicRoute && <Navbar />}
      <main className={`flex-grow ${isPublicRoute ? 'pt-20' : ''}`}>
        <Routes>
          <Route path="/" element={
            <PublicRoute>
              <SEO 
                title="होम"
                description="सीधी सोच सीधी बात - समाज के कल्याण के लिए समर्पित संगठन। हमारे कार्यक्रम, सेवाएं और जनसेवा के प्रयासों के बारे में जानें।"
                keywords="सीधी सोच सीधी बात, जनसेवा, समाज कल्याण, सामाजिक विकास, भारत, नई दिल्ली, सामाजिक कार्य, जनहित"
                url="/"
              />
              <HeroSection />
              <AboutSection />
              <JivanYatraSection />
              {/* <PressSection /> */}
              <ImpactSection />
              {/* <MissionSection /> */}
              <WorkSection />
              {/* <ServicesSection /> */}
              <VideoGallerySection />
              <Gallery />
              <AppointmentSection />
              <TestimonialsSection />
              <SocialMediaSection />
            </PublicRoute>
          } />
          
          {/* Gallery Page Route */}
          <Route path="/gallery" element={
            <PublicRoute>
              <GalleryPage />
            </PublicRoute>
          } />
          
          {/* Contact Page Route */}
          <Route path="/contact" element={
            <PublicRoute>
              <ContactPage />
            </PublicRoute>
          } />
          
          {/* About Page Route */}
          <Route path="/about" element={
            <PublicRoute>
              <AboutPage />
            </PublicRoute>
          } />
          
          {/* Karya (Work/Projects) List Page Route */}
          <Route path="/karya" element={
            <PublicRoute>
              <KaryaPage />
            </PublicRoute>
          } />
          {/* Karya (Work/Projects) Details Page Route */}
          <Route path="/karya/:id" element={
            <PublicRoute>
              <KaryaDetailPage />
            </PublicRoute>
          } />
          
          {/* Press Page Route */}
          <Route path="/press" element={
            <PublicRoute>
              <PressPage />
            </PublicRoute>
          } />
          
          {/* Video Page Route */}
          <Route path="/videos" element={
            <PublicRoute>
              <VideoPage />
            </PublicRoute>
          } />

          {/* Join Us Page Route */}
          <Route path="/joinus" element={
            <PublicRoute>
              <JoinUsPage />
            </PublicRoute>
          } />
          
          {/* Rachnaye (Poetry) List Page Route */}
          <Route path="/rachnaye" element={
            <PublicRoute>
              <RachnayePage />
            </PublicRoute>
          } />
          {/* Rachnaye (Poetry) Detail Page Route */}
          <Route path="/rachnaye/:id" element={
            <PublicRoute>
              <RachnayeDetailPage />
            </PublicRoute>
          } />
          {/* Blog List Page Route */}
          <Route path="/blog" element={
            <PublicRoute>
              <BlogPage />
            </PublicRoute>
          } />
          {/* Blog Detail Page Route */}
          <Route path="/blog/:id" element={
            <PublicRoute>
              <BlogDetailPage />
            </PublicRoute>
          } />
          {/* Sitemap Page Route */}
          <Route path="/sitemap" element={
            <PublicRoute>
              <Sitemap />
            </PublicRoute>
          } />
          
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="events" element={<EventsAdmin />} />
            <Route path="gallery" element={<GalleryAdmin />} />
            <Route path="videos" element={<VideosAdmin />} />
            <Route path="appointments" element={<AppointmentsAdmin />} />
            <Route path="contacts" element={<ContactsAdmin />} />
            <Route path="comments" element={<CommentsAdmin />} />
            <Route path="joinus" element={<JoinUsAdmin />} />
            <Route path="press" element={<PressAdmin />} />
            <Route path="rachnaye" element={<RachnayeAdmin />} />
            <Route path="blog" element={<BlogAdmin />} />
          </Route>
        </Routes>
      </main>
    </div>
  );
}

export default App;
